// @flow
export { default } from './EventLikeButton';



// WEBPACK FOOTER //
// ./src/components/event/EventLikeButton/index.js